import { CACHE_TTL } from '@ps/utils';

export const TEMPLATE_CACHE_TTL_MS = CACHE_TTL.DEFAULT;
